import { fetchJson, upload } from '../base'
import { getCurrentSchoolInfo } from '@/utils/schoolContext'

function getCurrentSchoolId() {
  return getCurrentSchoolInfo().schoolId || ''
}

function withCurrentSchoolId(params = {}) {
  const schoolId = getCurrentSchoolId()
  return schoolId && !params.schoolId
    ? Object.assign({ schoolId }, params)
    : params
}

export function getBaseTree(params = {}) {
  return fetchJson('/drs-serv/campus/tree', withCurrentSchoolId(params))
}

export function getCampusList(params = {}) {
  return fetchJson('/drs-serv/campus/query', Object.assign({
    current: 1,
    size: 1000
  }, params))
}

export function getEducationDeptList(params = {}) {
  return fetchJson('/drs-serv/educationDeptInfo/query', {
    keyword: params.keyword || ''
  })
}

export function getEducationCodeList(params = {}) {
  return fetchJson('/drs-serv/educationCode/query', {
    type: params.type
  })
}

export function getCanteenList(params = {}) {
  return fetchJson('/drs-serv/canteen/query', withCurrentSchoolId(params))
}

export function getCanteenDetail(id) {
  return fetchJson('/drs-serv/canteen/detail', { shopId: id })
}

export function addCanteen(data) {
  return fetchJson('/drs-serv/canteen/add', data)
}

export function updateCanteen(data) {
  return fetchJson('/drs-serv/canteen/update', data)
}

export function deleteCanteen(id) {
  return fetchJson('/drs-serv/canteen/del', { shopId: id })
}

export function importCanteen(data) {
  const forceImport = data && data.get ? data.get('forceImport') : ''
  return upload(`/drs-serv/canteen/import${forceImport !== '' ? `?forceImport=${encodeURIComponent(forceImport)}` : ''}`, data)
}

export function exportCanteen(params) {
  return fetchJson('/drs-serv/canteen/export', params)
}

export function getStaffList(params) {
  return fetchJson('/drs-serv/employeeInfo/query', params)
}

export function getStaffDetail(id) {
  return fetchJson('/drs-serv/employeeInfo/detail', { employeeId: id })
}

export function addStaff(data) {
  return fetchJson('/drs-serv/employeeInfo/add', data)
}

export function updateStaff(data) {
  return fetchJson('/drs-serv/employeeInfo/update', data)
}

export function deleteStaff(id) {
  const employeeIds = Array.isArray(id) ? id : [id]
  return fetchJson('/drs-serv/employeeInfo/del', { employeeIds })
}

export function importStaff(data) {
  return upload('/drs-serv/employeeInfo/import', data)
}

export function exportStaff(params) {
  return fetchJson('/drs-serv/employeeInfo/export', params)
}

export function getCateringUnitList(params) {
  return fetchJson('/drs-serv/cateringUnit/query', withCurrentSchoolId(params))
}

export function getCateringUnitDetail(id) {
  return fetchJson('/drs-serv/cateringUnit/detail', { unitId: id })
}

export function addCateringUnit(data) {
  return fetchJson('/drs-serv/cateringUnit/add', data)
}

export function updateCateringUnit(data) {
  return fetchJson('/drs-serv/cateringUnit/update', data)
}

export function deleteCateringUnit(id) {
  const unitIds = Array.isArray(id) ? id : [id]
  return fetchJson('/drs-serv/cateringUnit/delete', { unitIds })
}

export function importCateringUnit(data) {
  const forceImport = data && data.get ? data.get('forceImport') : ''
  return upload(`/drs-serv/cateringUnit/import${forceImport !== '' ? `?forceImport=${encodeURIComponent(forceImport)}` : ''}`, data)
}

export function exportCateringUnit(params) {
  return fetchJson('/drs-serv/cateringUnit/export', params)
}

export function getDeliveryUnitList(params) {
  return fetchJson('/drs-serv/foodDeliverUnit/query', params)
}

export function getDeliveryUnitDetail(deliveryUnitId) {
  return fetchJson('/drs-serv/foodDeliverUnit/detail', { deliveryUnitId })
}

export function addDeliveryUnit(data) {
  return fetchJson('/drs-serv/foodDeliverUnit/add', data)
}

export function updateDeliveryUnit(data) {
  return fetchJson('/drs-serv/foodDeliverUnit/update', data)
}

export function deleteDeliveryUnit(id) {
  const unitIds = Array.isArray(id) ? id : [id]
  return fetchJson('/drs-serv/foodDeliverUnit/delete', { unitIds })
}

export function importDeliveryUnit(data) {
  const forceImport = data && data.get ? data.get('forceImport') : ''
  return upload(`/drs-serv/foodDeliverUnit/import${forceImport !== '' ? `?forceImport=${encodeURIComponent(forceImport)}` : ''}`, data)
}

export function exportDeliveryUnit(params) {
  return fetchJson('/drs-serv/foodDeliverUnit/export', params)
}

export function getFoodDeliveryCategoryTree(params = {}) {
  return fetchJson('/drs-serv/foodDeliveryCategory/tree', params)
}

export function getDeliveryCooperationList(params) {
  return fetchJson('/drs-serv/deliveryUnitCanteen/query', params)
}

export function getDeliveryCooperationDetail(partnerId) {
  return fetchJson('/drs-serv/deliveryUnitCanteen/detail', { partnerId })
}

export function getDeliveryCooperationCanteenOptions(params = {}) {
  return fetchJson('/drs-serv/canteen/query', withCurrentSchoolId(params))
}

export function addDeliveryCooperation(data) {
  return fetchJson('/drs-serv/deliveryUnitCanteen/add', data)
}

export function updateDeliveryCooperation(data) {
  return fetchJson('/drs-serv/deliveryUnitCanteen/update', data)
}

export function deleteDeliveryCooperation(id) {
  const partnerIds = Array.isArray(id) ? id : [id]
  return fetchJson('/drs-serv/deliveryUnitCanteen/delete', { partnerIds })
}

export function importDeliveryCooperation(data) {
  const forceImport = data && data.get ? data.get('forceImport') : ''
  return upload(`/drs-serv/deliveryUnitCanteen/import${forceImport !== '' ? `?forceImport=${encodeURIComponent(forceImport)}` : ''}`, data)
}

export function exportDeliveryCooperation(params) {
  return fetchJson('/drs-serv/deliveryUnitCanteen/export', params)
}



// WEBPACK FOOTER //
// ./src/api/base-info/base-info.api.js